import Angular from "angular";
import Template from "./vehiclecheck-state-icon.html";

export default Angular.module('vehiclecheck-state-icon', [])
    .component('vehiclecheckStateIcon', {
        template: Template,
        bindings: {
            checkState: '<',
            withLabel: '@'
        },
    })



// WEBPACK FOOTER //
// ./src/modules/main/components/vehiclecheck-state-icon/vehiclecheck-state-icon.js